// extracted by mini-css-extract-plugin
module.exports = {"additionalInfo":"AdditionalInfo_additionalInfo__3DOcO","additionalInfoItem":"AdditionalInfo_additionalInfoItem__1mQYw"};